import cldrListPatterns from '../data/main/en/listPatterns.json';
import cldrCaGregorian from '../data/main/en/caGregorian.json';
import cldrTimeZoneNames from '../data/main/en/timeZoneNames.json';
import cldrNumbers from '../data/main/en/numbers.json';
import cldrTerritories from '../data/main/en/territories.json';
import cldrLanguages from '../data/main/en/languages.json';
import cldrCurrencies from '../data/main/en/currencies.json';
import dateTimeStyles from '../data/main/en/dateTimeStyles.json';
import cldrDateFields from '../data/main/en/dateFields.json';

export default {
  cldr: {
    cldrListPatterns,
    cldrCaGregorian,
    cldrTimeZoneNames,
    cldrNumbers,
    cldrTerritories,
    cldrLanguages,
    cldrCurrencies,
    cldrDateFields,
  },
  dateTimeStyles,
};
